import React from "react";

// Shared position filter — Row 1 = larger primary (ALL/FWD/DEF/G),
// Row 2 = smaller secondary (LW/C/RW/LD/RD). Used by Leaderboards and Teams > Players.
const PRIMARY = [
    { k: "all", l: "ALL", color: "#9D4CDD", solidText: "#fff" },
    { k: "fwd", l: "FWD", color: "#E9D5FF", solidText: "#0A0B10" },
    { k: "def", l: "DEF", color: "#93C5FD", solidText: "#0A0B10" },
    { k: "g", l: "G", color: "#86EFAC", solidText: "#0A0B10" },
];
const SECONDARY = [
    { k: "w", l: "W", color: "#E9D5FF" },
    { k: "lw", l: "LW", color: "#E9D5FF" },
    { k: "c", l: "C", color: "#E9D5FF" },
    { k: "rw", l: "RW", color: "#E9D5FF" },
    { k: "ld", l: "LD", color: "#93C5FD" },
    { k: "rd", l: "RD", color: "#93C5FD" },
];

export function PositionFilterTabs({ value, onChange, onSecondary = null, testIdPrefix = "pos", available = null, singleRow = false, order = null }) {
    const show = (k) => k === "all" || !available || available.includes(k);
    const primary = PRIMARY.filter((f) => show(f.k));
    const secondary = SECONDARY.filter((f) => show(f.k));

    const btn = (f, primaryRow) => {
        // Secondary (specific) positions can act as "jump" buttons — they don't
        // hold an active state when onSecondary is provided.
        const isJump = !primaryRow && typeof onSecondary === "function";
        const active = !isJump && value === f.k;
        const solidText = f.solidText || "#0A0B10";
        const sizeCls = singleRow
            ? "px-2 py-1 text-[11px]"
            : primaryRow ? "py-2 sm:py-2.5 text-xs sm:text-sm" : "py-1.5 text-[11px]";
        return (
            <button
                key={f.k}
                onClick={() => (isJump ? onSecondary(f.k) : onChange(f.k))}
                data-testid={`${testIdPrefix}-pos-${f.k}`}
                style={active ? { background: `${f.color}26`, borderColor: `${f.color}59`, color: f.color } : { color: f.color }}
                className={`rounded-md border font-bold uppercase tracking-wider transition-colors ${sizeCls} ${active ? "" : "border-white/15 bg-black/25 hover:text-white"}`}
            >
                {f.l}
            </button>
        );
    };

    // Single compact row — all positions on one line (used by Leaderboards).
    if (singleRow) {
        const allDefs = [...PRIMARY, ...SECONDARY];
        const ordered = order
            ? order.map((k) => allDefs.find((f) => f.k === k)).filter((f) => f && show(f.k))
            : [...primary, ...secondary];
        return (
            <div className="flex flex-wrap gap-1" data-testid={`${testIdPrefix}-position-filter`}>
                {ordered.map((f) => btn(f, true))}
            </div>
        );
    }

    return (
        <div className="space-y-1.5" data-testid={`${testIdPrefix}-position-filter`}>
            <div className="grid gap-1.5" style={{ gridTemplateColumns: `repeat(${primary.length}, minmax(0, 1fr))` }}>
                {primary.map((f) => btn(f, true))}
            </div>
            {secondary.length > 0 && (
                <div className="grid gap-1.5" style={{ gridTemplateColumns: `repeat(${secondary.length}, minmax(0, 1fr))` }}>
                    {secondary.map((f) => btn(f, false))}
                </div>
            )}
        </div>
    );
}
